import { createAction } from 'redux-act';

// create holiday by admin
const createHolidayRequest = createAction('CREATE_HOLIDAY_REQUEST', data => data);
const createHolidaySuccess = createAction('CREATE_HOLIDAY_SUCCESS', data => data);
const createHolidayError = createAction('CREATE_HOLIDAY_ERROR');

// get holiday
const getHolidayRequest = createAction('GET_HOLIDAY_REQUEST', data => data);
const getHolidaySuccess = createAction('GET_HOLIDAY_SUCCESS', data => data);
const getHolidayError = createAction('GET_HOLIDAY_ERROR');

// update holiday
const updateHolidayRequest = createAction('UPADTE_HOLIDAY_REQUEST', data => data);
const updateHolidaySuccess = createAction('UPADTE_HOLIDAY_SUCCESS', data => data);
const updateHolidayError = createAction('UPADTE_HOLIDAY_ERROR');

// delete holiday
const deleteHolidayRequest = createAction('DELETE_HOLIDAY_REQUEST', data => data);
const deleteHolidaySuccess = createAction('DELETE_HOLIDAY_SUCCESS', data => data);
const deleteHolidayError = createAction('DELETE_HOLIDAY_ERROR');

// sample download
const sampleDownloadRequest = createAction('SAMPLE_DOWNLOAD_REQUEST', data => data);
const sampleDownloadSuccess = createAction('SAMPLE_DOWNLOAD_SUCCESS', data => data);
const sampleDownloadError = createAction('SAMPLE_DOWNLOAD_ERROR');

// delete holiday
const uploadHolidayRequest = createAction('UPLOAD_HOLIDAY_REQUEST', data => data);
const uploadHolidaySuccess = createAction('UPLOAD_HOLIDAY_SUCCESS', data => data);
const uploadHolidayError = createAction('UPLOAD_HOLIDAY_ERROR');

// clear existing create employee action
const handleClearHolidayStore = createAction('HANDLE_CLEAR_HOLIDAY_STORE', data => data);

export default {
    createHolidayRequest,
    createHolidaySuccess,
    createHolidayError,

    getHolidayRequest,
    getHolidaySuccess,
    getHolidayError,

    updateHolidayRequest,
    updateHolidaySuccess,
    updateHolidayError,

    deleteHolidayRequest,
    deleteHolidaySuccess,
    deleteHolidayError,

    sampleDownloadRequest,
    sampleDownloadSuccess,
    sampleDownloadError,

    uploadHolidayRequest,
    uploadHolidaySuccess,
    uploadHolidayError,

    handleClearHolidayStore,
}